var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(438.775 -159.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M-426.275,159.519a12.5,12.5,0,0,1,12.5,12.539A12.506,12.506,0,0,1-426.3,184.519a12.5,12.5,0,0,1-12.474-12.592A12.508,12.508,0,0,1-426.275,159.519Zm-.028,10.169a3.355,3.355,0,0,0-.217-.273q-1.341-1.346-2.687-2.688a1.62,1.62,0,0,0-1.76-.45,1.659,1.659,0,0,0-.624,2.783c.907.921,1.827,1.83,2.741,2.744.066.066.128.136.2.215-.075.08-.138.149-.2.215q-1.362,1.363-2.724,2.725a1.612,1.612,0,0,0-.447,1.737,1.659,1.659,0,0,0,2.778.647c.93-.91,1.844-1.837,2.761-2.762a1.008,1.008,0,0,0,.136-.26c.142.133.193.179.242.227q1.381,1.38,2.762,2.761a1.627,1.627,0,0,0,1.735.461,1.663,1.663,0,0,0,.65-2.793c-.907-.921-1.827-1.83-2.741-2.745-.066-.066-.128-.136-.2-.214.075-.08.138-.149.2-.215q1.353-1.354,2.707-2.705a1.713,1.713,0,0,0,.547-1.145,1.674,1.674,0,0,0-.973-1.614,1.637,1.637,0,0,0-1.872.337c-.517.5-1.021,1.017-1.53,1.526Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M-305.08,290.918l1.484-1.486c.509-.509,1.013-1.025,1.53-1.526a1.637,1.637,0,0,1,1.872-.337,1.674,1.674,0,0,1,.973,1.614,1.713,1.713,0,0,1-.547,1.145q-1.357,1.349-2.707,2.706c-.066.066-.129.136-.2.215.074.079.137.148.2.214.914.915,1.834,1.824,2.741,2.745a1.663,1.663,0,0,1-.65,2.793,1.626,1.626,0,0,1-1.735-.461q-1.384-1.378-2.762-2.761c-.048-.048-.1-.094-.242-.227a1.01,1.01,0,0,1-.136.26c-.916.924-1.83,1.852-2.761,2.762a1.659,1.659,0,0,1-2.778-.647,1.612,1.612,0,0,1,.447-1.737q1.359-1.365,2.724-2.725c.066-.066.129-.136.2-.215-.074-.079-.137-.149-.2-.215-.914-.915-1.834-1.823-2.741-2.744a1.659,1.659,0,0,1,.624-2.783,1.62,1.62,0,0,1,1.76.45q1.348,1.34,2.687,2.688A3.361,3.361,0,0,1-305.08,290.918Z",
    transform: "translate(-121.223 -121.23)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagclose);
export default __webpack_public_path__ + "static/media/tagclose.944a651953a9ba8dffbdf4a681009a8b.svg";
export { ForwardRef as ReactComponent };